import React from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { format, parseISO } from 'date-fns';
import PropTypes from 'prop-types';

import Card from '@/components/common/Card';
import clientImage from '@/components/common/icons/client-details.svg';
import exclamationCircleImage from '@/images/icons/exclamation-circle.svg';

const ClientCard = ({ data }) => {
  const params = useParams();
  const intl = useIntl();
  const numberFormat = new Intl.NumberFormat('pt-BR', {
    maximumSignificantDigits: 5,
  });
  const status = params.status || 'enabled';

  return (
    <Card className="isInspector" url={`/clients/${status}/${data.id}`}>
      <div className="flex items-center">
        <div className="relative w-8 mr-2 text-[#45668c] flex-shrink-0">
          <img src={clientImage} alt={intl.formatMessage({ id: 'CUSTOMER' })} className="max-w-full max-h-full" />
        </div>
        <div className="relative top-[3px] text-[0.875em] leading-none font-bold text-[#393939]">{data.name}</div>
        {data?.invalid_address && (
          <div className="relative top-[3px] flex items-center ml-[0.875em] text-[0.875em] leading-[12px] text-[#b92d2f]">
            <img src={exclamationCircleImage} alt="Exclamação" className="h-[12px] mr-[0.3em]" />
            {intl.formatMessage({ id: 'INVALID_ADDRESS' })}
          </div>
        )}
      </div>
      <div className="flex mt-[1em] text-[0.8125em] text-[#919191]">
        {data.phone && <div className="font-bold">{data.phone}</div>}
        {data.email && (
          <div className="font-semibold before:content-['•'] before:mx-[5px]">
            {data.email}
          </div>
        )}
      </div>
      <div className="flex mt-[1em] text-[0.8125em] text-[#919191]">
        {data.last_order
          ? `${intl.formatMessage({ id: 'LAST_MOVE_ON_MESSAGE' })} ${format(parseISO(data.last_order), "dd/MM/yyyy 'às' HH:mm")}`
          : intl.formatMessage({ id: 'NO_REGISTERED_MOVEMENTS_MESSAGE' })}
      </div>
      <div className="absolute top-1/2 right-[1.625em] -translate-y-1/2 min-w-[92px] p-[1.125em] border-2 border-[#e3e3e3] rounded-[8px] text-center text-[#919191] leading-none">
        <div className="text-[0.625em] font-medium">{intl.formatMessage({ id: 'BALANCE' })}</div>
        <div className="mt-[0.3125em] text-[1.25em] font-bold">{numberFormat.format((data.balance / 100).toFixed(0))}</div>
      </div>
    </Card>
  );
};

ClientCard.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ClientCard;
